import { PageTitle } from '@/components/custom/PageTitle';
import { PersonalSettings } from './PersonalSettingsForm';
import { AccountSettings } from './AccountSettingsForm';

export const MyAccount = () => {
  return (
    <div className="protectedPageLayout">
      <PageTitle title="My Account" />
      <PersonalSettings />
      <AccountSettings />
    </div>
  )
}
